import React, { FC } from 'react';
import styled from 'styled-components';
import { CommonComponentProps } from '@cld/common-definitions';
import { combineValues } from '@cld/component-theme';
import { typography, typographyMixin, TypographyProps } from '@cld/typography';
import { asStyledComponent } from '@cld/component-enhancer';
import { theme } from './theme';

export interface LabelProps extends CommonComponentProps<'label'> {
  /**
   * If true, small red asterisk is added at the end
   */
  mandatory?: boolean;
  /**
   * Sets or retrieves the object to which the given label object is assigned.
   */
  htmlFor?: HTMLLabelElement['htmlFor'];
}

const Root = styled.label`
  display: block;
  ${combineValues(theme.label.typography, (props) => typographyMixin(props as TypographyProps))};
  margin: ${theme.label.margin.vertical} 0;
  cursor: pointer;
`;

const Mandatory = styled.span`
  ${combineValues(theme.label.mandatoryTypography, (props) => typographyMixin(props as TypographyProps))};
`;

export const Label = asStyledComponent<FC<LabelProps>>(({ mandatory, children, ...rest }) => (
  <Root {...rest}>
    {children}
    {mandatory && <Mandatory>&nbsp;*</Mandatory>}
  </Root>
));
